






































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

import { CrudList, DataTable, NoDataFound } from '../../components';

import { CrudListMixin } from '../../mixins/crud-list.mixin';

import { ROUTER_CONSTS } from '../../router/router.consts';

export default {
  name: 'equalize-list',
  components: {
    CrudList,
    DataTable,
    NoDataFound
  },
  mixins: [CrudListMixin],
  data: function () {
    const messages = this.$epb.messages.tools.equalize;
    return {
      dataType: ActionTypeEnum.EQUALIZE,
      routes: {
        create: ROUTER_CONSTS.routes.equalize.create,
        update: ROUTER_CONSTS.routes.equalize.update
      },
      columns: [
        {
          id: 'title',
          text: messages.fields.title.label,
          sortable: true
        }, {
          id: 'enabledTime',
          text: messages.fields.enabledTime.label,
          sortable: true
        }, {
          id: 'meta.updateDate',
          text: messages.fields.updateDate.label,
          sortable: true
        }, {
          id: 'enabled',
          text: messages.fields.enabled.label,
          sortable: true
        }
      ],
      messages: messages
    };
  },
  methods: {
    getEnabledTimeText: function (enabledTimeInMillis = 0) {
      const timePeriodsMessages = this.messages.enabledTimePeriods;
      if (enabledTimeInMillis === 0) {
        return timePeriodsMessages.zero;
      }
      const enabledTimePeriods: string[] = [];
      let enabledHours = Math.floor(((enabledTimeInMillis / 1000) / 60) / 60);
      let enabledDays = Math.floor(enabledHours / 24);
      enabledHours -= (enabledDays * 24);
      const enabledYears = Math.floor(enabledDays / 365);
      if (enabledYears > 0) {
        const yearsMessage = ((enabledYears > 1) ? timePeriodsMessages.year.plural : timePeriodsMessages.year.singular);
        enabledTimePeriods.push(`${ enabledYears } ${ yearsMessage }`);
      }
      enabledDays -= (enabledYears * 365);
      const enabledMonths = Math.floor(enabledDays / 30);
      if (enabledMonths > 0) {
        const monthsMessage = ((enabledMonths > 1) ? timePeriodsMessages.month.plural : timePeriodsMessages.month.singular);
        enabledTimePeriods.push(`${ enabledMonths } ${ monthsMessage }`);
      }
      enabledDays -= (enabledMonths * 30);
      if (enabledDays > 0) {
        const daysMessage = ((enabledDays > 1) ? timePeriodsMessages.day.plural : timePeriodsMessages.day.singular);
        enabledTimePeriods.push(`${ enabledDays } ${ daysMessage }`);
      }
      if (enabledHours > 0) {
        const hoursMessage = ((enabledHours > 1) ? timePeriodsMessages.hour.plural : timePeriodsMessages.hour.singular);
        enabledTimePeriods.push(`${ enabledHours } ${ hoursMessage }`);
      }
      if (!enabledTimePeriods.length) {
        return `${ timePeriodsMessages.lessThan } 1 ${ timePeriodsMessages.hour.singular }`;
      }
      return enabledTimePeriods.join(' ');
    }
  }
};

